import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Navigation = ({ currentPage }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    setMobileMenuOpen(false);
    navigate('/auth');
  };

  const handleNavClick = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      <nav className="nav">
        <div 
          className="nav-logo" 
          onClick={() => navigate('/')}
        >
          <div className="nav-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </div>
          <span className="nav-logo-text">NearBy<span>Service</span></span>
        </div>
        
        <div className="nav-links">
          <button 
            className={`nav-link ${currentPage === '/' ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            Home
          </button>
          <button 
            className={`nav-link ${currentPage === '/services' ? 'active' : ''}`}
            onClick={() => navigate('/services')}
          >
            Services
          </button>
          <button 
            className={`nav-link ${currentPage === '/products' ? 'active' : ''}`}
            onClick={() => navigate('/products')}
          >
            Products
          </button>
          {user?.user_type === 'vendor' && (
            <button 
              className={`nav-link ${currentPage === '/vendor-dashboard' ? 'active' : ''}`}
              onClick={() => navigate('/vendor-dashboard')}
            >
              Dashboard
            </button>
          )}
        </div>
        
        <div className="nav-actions">
          {user ? (
            <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
              <span style={{fontSize: '0.875rem', color: 'var(--text-2)'}}>
                {user.name} <span style={{fontSize: '0.75rem', color: 'var(--text-3)'}}>({user.user_type})</span>
              </span>
              <button className="btn btn-secondary btn-sm" onClick={handleLogout}>
                Logout
              </button>
            </div>
          ) : (
            <>
              <button className="btn btn-secondary btn-sm" onClick={() => navigate('/auth')}>
                Sign In
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => navigate('/add-listing')}>
                + List Service
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger Menu */}
        <button 
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {/* Mobile Menu Drawer */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-content">
              <div className="mobile-menu-user">
                {user && (
                  <div style={{fontSize: '0.9rem', color: 'var(--text-1)', marginBottom: '16px'}}>
                    <div style={{fontWeight: 600}}>{user.name}</div>
                    <div style={{fontSize: '0.75rem', color: 'var(--text-3)'}}>({user.user_type})</div>
                  </div>
                )}
              </div>

              <nav className="mobile-nav-links">
                <button 
                  className={`mobile-nav-link ${currentPage === '/' ? 'active' : ''}`}
                  onClick={() => handleNavClick('/')}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  Home
                </button>
                <button 
                  className={`mobile-nav-link ${currentPage === '/services' ? 'active' : ''}`}
                  onClick={() => handleNavClick('/services')}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M6 9h12M6 9H4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9h-2M9 9V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4"/>
                  </svg>
                  Services
                </button>
                <button 
                  className={`mobile-nav-link ${currentPage === '/products' ? 'active' : ''}`}
                  onClick={() => handleNavClick('/products')}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                  </svg>
                  Products
                </button>
                {user?.user_type === 'vendor' && (
                  <button 
                    className={`mobile-nav-link ${currentPage === '/vendor-dashboard' ? 'active' : ''}`}
                    onClick={() => handleNavClick('/vendor-dashboard')}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                    </svg>
                    Dashboard
                  </button>
                )}
                <button 
                  className="mobile-auth-register"
                  onClick={() => handleNavClick('/add-listing')}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
                  </svg>
                  List Service
                </button>
              </nav>

              {!user && (
                <div className="mobile-auth-section">
                  <button 
                    className="mobile-nav-link"
                    onClick={() => handleNavClick('/auth')}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"/>
                    </svg>
                    Sign In
                  </button>
                  <button 
                    className="mobile-nav-link"
                    onClick={() => navigate('/add-listing')}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM1 21h22M12 11v8M16 15H8"/>
                    </svg>
                    Register
                  </button>
                </div>
              )}

              {user && (
                <button 
                  className="mobile-nav-logout"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Mobile Floating Action Button */}
      <div className="mobile-floating-actions">
        {user ? (
          <button 
            className="btn btn-primary btn-sm"
            onClick={() => navigate('/add-listing')}
            style={{width: '100%'}}
          >
            + List Service
          </button>
        ) : (
          <button 
            className="btn btn-secondary btn-sm"
            onClick={() => navigate('/auth')}
            style={{width: '100%'}}
          >
            Sign In
          </button>
        )}
      </div>

      {/* Desktop Floating Vendor Button */}
      {user?.user_type !== 'vendor' && (
        <button 
          className="floating-vendor-btn"
          onClick={() => navigate('/add-listing')}
          title="List your service for free"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M5 12h14"/>
          </svg>
          <span>List Service</span>
        </button>
      )}
    </>
  );
};

export default Navigation;
